// 霹雳州球场数据
// Perak Golf Courses

export const PERAK_COURSES = {
  "CLEARWATER_SANCTUARY_GOLF_RESORT": {
    shortName: "CSGR",
    fullName: "Clearwater Sanctuary Golf Resort",
    location: ["Batu Gajah", "Perak", "Malaysia"],
    pars: [4,4,3,5,4,5,3,4,4, 4,3,4,5,4,4,4,3,5],
    index: [15,7,13,9,3,11,17,5,1, 2,18,16,14,4,8,6,10,12]
  },

  "DAMAI_LAUT_GOLF_AND_COUNTRY_CLUB": {
    shortName: "DLGCC",
    fullName: "Damai Laut Golf & Country Club",
    location: ["Lumut", "Perak", "Malaysia"],
    pars: [4,5,3,4,5,4,3,4,4, 4,5,4,3,4,4,4,3,5],
    index: [17,13,7,3,9,1,11,5,15, 16,8,6,18,4,12,2,10,14]
  },

  "EASTWOOD_VALLEY_GOLF_AND_COUNTRY_CLUB": {
    shortName: "EVGCC",
    fullName: "Eastwood valley golf and country club",
    location: ["Ipoh", "Perak", "Malaysia"],
    pars: [5,4,3,4,4,5,4,3,4, 5,4,4,3,4,4,4,3,5],
    index: [11,3,9,17,13,5,1,15,7, 14,6,16,8,2,10,18,12,4]
  },

  "KELAB_GOLF_BRIGED_UTARA": {
    shortName: "KGBU",
    fullName: "Kelab Golf Briged Utara",
    location: ["Tanjung Rambutan", "Perak", "Malaysia"],
    pars: [4,5,3,4,5,3,3,4,4],
    index: [3,2,6,4,1,9,7,8,5]
  },

  "KELAB_GOLF_KINTA": {
    shortName: "KGK",
    fullName: "Kelab Golf Kinta",
    location: ["Batu Gajah", "Perak", "Malaysia"],
    pars: [5,3,4,4,3,4,3,4,4, 4,4,5,3,4,4,5,3,4],
    index: [3,15,7,9,13,5,17,1,11, 12,10,6,16,2,8,4,18,14]
  },

  "KELAB_GOLF_KUALA_KANGSAR": {
    shortName: "KGKK",
    fullName: "Kelab Golf Kuala Kangsar",
    location: ["Kuala Kangsar", "Perak", "Malaysia"],
    pars: [4,3,4,4,5,3,4,4,4],
    index: [8,9,3,6,2,7,1,4,5]
  },

  "KELAB_GOLF_SAMUDERA": {
    shortName: "KGS",
    fullName: "Kelab Golf Samudera",
    location: ["Lumut", "Perak", "Malaysia"],
    pars: [4,4,5,3,4,4,3,5,3, 4,4,5,3,4,4,3,5,3],
    index: [11,9,3,15,7,1,17,5,13, 12,10,4,16,8,2,18,6,14]
  },

  "MERU_VALLEY_GOLF_RESORT_VALLEY_RIVER": {
    shortName: "MVGR-VR",
    fullName: "Meru Valley Golf Resort (Valley + River)",
    location: ["Ipoh", "Perak", "Malaysia"],
    pars: [4,3,5,3,4,4,5,4,4, 4,5,3,4,4,5,4,3,4],
    index: [7,15,9,17,3,13,1,11,5, 8,12,18,16,10,6,4,14,2]
  },

  "MERU_VALLEY_GOLF_RESORT_VALLEY_WATERFALL": {
    shortName: "MVGR-VW",
    fullName: "Meru Valley Golf Resort (Valley + Waterfall)",
    location: ["Ipoh", "Perak", "Malaysia"],
    pars: [4,3,5,3,4,4,5,4,4, 4,4,3,4,5,4,3,5,4],
    index: [7,15,9,17,3,13,1,11,5, 12,2,16,4,8,14,10,18,6]
  },

  "MERU_VALLEY_GOLF_RESORT_WATERFALL_RIVER": {
    shortName: "MVGR-WR",
    fullName: "Meru Valley Golf Resort (Waterfall + River)",
    location: ["Ipoh", "Perak", "Malaysia"],
    pars: [4,4,3,4,5,4,3,5,4, 4,5,3,4,4,5,4,3,4],
    index: [11,1,15,3,7,13,9,17,5, 8,12,18,16,10,6,4,14,2]
  },

  "ROYAL_PERAK_GOLF_CLUB": {
    shortName: "RPGC",
    fullName: "Royal Perak Golf Club",
    location: ["Ipoh", "Perak", "Malaysia"],
    pars: [5,4,3,4,3,5,4,4,4, 5,4,4,3,4,4,4,3,5],
    index: [11,5,15,3,17,9,13,1,7, 12,6,10,16,2,4,14,18,8]
  },

  "TAIPING_GOLF_RESORT": {
    shortName: "TGR",
    fullName: "Taiping Golf Resort",
    location: ["Taiping", "Perak", "Malaysia"],
    pars: [5,4,4,3,4,4,4,3,5, 4,4,4,4,3,4,5,3,5],
    index: [1,5,7,17,3,13,11,15,9, 6,12,14,10,18,8,4,16,2]
  },

  "TELUK_INTAN_GOLF_AND_COUNTRY_CLUB": {
    shortName: "TIGCC",
    fullName: "Teluk Intan Golf & Country Club",
    location: ["Teluk Intan", "Perak", "Malaysia"],
    pars: [4,4,4,5,3,5,3,4,4, 4,5,4,3,4,4,5,3,4],
    index: [3,17,11,1,15,5,7,13,9, 2,6,10,18,16,14,4,12,8]
  }
};

export default PERAK_COURSES;
